import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Footer from './comps/Footer';
import Navbar from './comps/Navbar';
import UserReceipt from './comps/Receipts/UserReceipt';
import Feature from './comps/Feature';
import Home from './comps/Home';
import Library from './comps/Library';
import Profile from './comps/Profile';
import Receipts from './comps/Receipts';
import Billing from './comps/Billing';
import Collection from './comps/Collection';
import { connect } from 'react-redux';

const App = () => (
  <Switch>
    <Route path="/receipts/:id" component={UserReceipt} />
    <Route component={Main} />
  </Switch>
);

let Main = ({ showModal }) => (
  <div className="main" id="content">
    <Navbar />
    {showModal && <Billing />}
    <main>
      <Switch>
        <Route exact path="/" component={Home} />
        <Route path="/feature/:id" component={Feature} />
        <Route path="/profile" component={Profile} />
        <Route path="/library" component={Library} />
        <Route path="/orders" component={Receipts} />
        <Route path="/collection/:name" component={Collection} />
      </Switch>
    </main>
    <Footer />
  </div>
);

const mapStateToProps = state => ({
  showModal: state.modal.showModal
});

Main = connect(mapStateToProps)(Main);

export default App;



// WEBPACK FOOTER //
// ./src/App.js